import {createFeatureSelector, createSelector} from '@ngrx/store';
import {AuthState} from './auth.reducer';

export const selectAuthState = createFeatureSelector<AuthState>('auth');

export const isLoginLoading = createSelector(
  selectAuthState,
  (state) => state.isLoginLoading
);

export const isSignupLoading = createSelector(
  selectAuthState,
  (state) => state.isSignupLoading
);

export const isForgotPasswordLoading = createSelector(
  selectAuthState,
  (state) => state.isForgotPasswordLoading
);

export const isResetPasswordLoading = createSelector(
  selectAuthState,
  (state) => state.isResetPasswordLoading
);

export const isVerifyEmailLoading = createSelector(
  selectAuthState,
  (state) => state.isVerifyEmailLoading
);

export const isResendOtpLoading = createSelector(
  selectAuthState,
  (state) => state.isResendOtpLoading
);

export const isValidatePasswordResetOtpLoading = createSelector(
  selectAuthState,
  (state) => state.isValidatePasswordResetOtpLoading
);

export const forgotPasswordEmail = createSelector(
  selectAuthState,
  (state) => state.forgotPasswordEmail
);
